export default __webpack_public_path__ + "static/media/Highlights-Sphere_rollover.a6c5ed4b.png";